/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import Loader from "../loader/loader";
import FeedbackList from "./FeedbackList";
import ImageModal from "./AttachmentModal";
import { useDispatch } from "react-redux";
import { getAllUserFeedbacks } from "../../reducers/adminReducers";
import { useSelector } from "react-redux";
import NoDataFound from "../Generik/NoDataFound";
const Feedback = () => {
  const [isImageModalOpen, setImageModalOpen] = useState(false);
  const [attachment, setAttachment] = useState({ file: "", type: "" });
  const [selectedMessage, setSelectedMessage] = useState("");
  const result = useSelector((state) => state.admin);
  const { userFeedBackList } = result || {};
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleImageClick = (imageUrl, message, attachmentType) => {
    setSelectedMessage(message);
    setImageModalOpen(true);
    setAttachment({ file: imageUrl, type: attachmentType });
  };

  const getFeedbacks = async () => {
    setLoading(true);
    const response = await dispatch(getAllUserFeedbacks());
    if (response?.payload) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getFeedbacks();
  }, []);

  return (
    <Fragment>
      <Breadcrumb title="Feedback" parent="Feedback" />
      <Container fluid={true}>
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Feedback list</h5>
            </CardHeader>
            <CardBody>
              {!loading ? (
                userFeedBackList.length > 0 ? (
                  <FeedbackList
                    multiSelectOption={true}
                    myData={userFeedBackList}
                    pageSize={10}
                    pagination={true}
                    class="-striped -highlight"
                    onImageClick={handleImageClick}
                  />
                ) : (
                  <NoDataFound data="Feedback Data" />
                )
              ) : (
                <Loader />
              )}
            </CardBody>
          </Card>
        </div>
      </Container>

      <ImageModal
        isOpen={isImageModalOpen}
        onClose={() => setImageModalOpen(false)}
        altText="Feedback Attachment"
        message={selectedMessage}
        attachment={attachment}
      />
    </Fragment>
  );
};

export default Feedback;
